import {
  channelMatchesTab,
  channelTabMembers,
  type ChannelAccountDTO,
  type ChannelType,
  type ConversationListItemDTO,
} from '@sac/contracts'
import { ChannelMark, Icon, channelName } from './icons'

const DISPLAY_CHANNELS: ChannelType[] = [
  'whatsapp',
  'mercadolivre',
  'shopee',
  'amazon',
  'instagram',
  'tiktok',
  'site',
  'email',
]

export function ChannelTabs({
  items,
  active,
  onSelect,
  channelAccounts,
}: {
  items: ConversationListItemDTO[]
  active: ChannelType | 'todos'
  onSelect: (c: ChannelType | 'todos') => void
  /** Drives the greyed-out treatment for channels nobody has set up yet. */
  channelAccounts: ChannelAccountDTO[]
}) {
  // Counted with the SAME rule the filter uses. When these two disagreed, a tab advertised 23
  // conversations and opened onto a list that hid 616 others.
  const countFor = (c: ChannelType | 'todos') =>
    items.filter((i) => channelMatchesTab(c, i.channelType)).length

  const isConnected = (c: ChannelType) =>
    channelTabMembers(c).some((member) =>
      channelAccounts.some((a) => a.channelType === member && a.connectionStatus === 'connected'),
    )

  return (
    <div className="chan-tabs">
      <button className={`chan ${active === 'todos' ? 'on' : ''}`} onClick={() => onSelect('todos')}>
        <span style={{ width: 16, height: 16, display: 'grid', placeItems: 'center', color: 'var(--text-3)' }}>
          <Icon name="chat" />
        </span>
        Todos
        {countFor('todos') > 0 && <span className="cnt">{countFor('todos')}</span>}
      </button>
      {DISPLAY_CHANNELS.map((c) => {
        const n = countFor(c)
        const connected = isConnected(c)
        return (
          <button
            key={c}
            className={`chan ${active === c ? 'on' : ''} ${connected ? '' : 'disconnected'}`}
            onClick={() => onSelect(c)}
            title={connected ? undefined : `${channelName(c)} não está conectado`}
          >
            <ChannelMark channel={c} size={16} />
            {channelName(c)}
            {n > 0 && <span className="cnt">{n}</span>}
          </button>
        )
      })}
    </div>
  )
}
